import { keys, omit } from 'ramda';

import type {
  ParagraphChildElement,
  ParagraphElement,
  ParagraphProps,
  TextProps,
} from '../internal';
import {
  createDefaultText,
  defaultStyleVariant,
  generateLocationId,
  paragraphType,
} from '../internal';

export const paragraphKeysObj: Record<keyof ParagraphProps, null> = {
  alignment: null,
  borders: null,
  contextualSpacing: null,
  glyphProps: null,
  indentationFirstLine: null,
  indentationLeft: null,
  indentationRight: null,
  lineSpacing: null,
  listLevel: null,
  listProps: null,
  locationId: null,
  shade: null,
  spacingAfter: null,
  spacingBefore: null,
  suggestedEdits: null,
  type: null,
  variant: null,
};
export const paragraphPropKeys = keys(paragraphKeysObj);

export interface CreateParagraphArgs {
  paraProps?: Partial<ParagraphElement>;
  text?: string;
  textProps?: Partial<TextProps>;
}

export function createDefaultParagraph(args: CreateParagraphArgs = {}): ParagraphElement {
  const { paraProps = {}, text = '', textProps = {} } = args;

  return {
    alignment: 'left',
    children: [createDefaultText(textProps, text)],
    indentationFirstLine: 0,
    indentationLeft: 0,
    indentationRight: 0,
    lineSpacing: 1.15,
    locationId: generateLocationId(),
    spacingAfter: 0,
    spacingBefore: 0,
    suggestedEdits: [],
    type: paragraphType,
    variant: defaultStyleVariant,
    // Ensure locationId is generated fresh for each paragraph so we guarantee unique locationIds.
    ...omit(['locationId'] satisfies Array<keyof ParagraphProps>, paraProps),
  };
}

export interface CreateParagraphWithChildrenArgs {
  children: ParagraphChildElement[];
  paraProps?: Partial<ParagraphProps>;
}

export function createParagraphWithChildren(
  args: CreateParagraphWithChildrenArgs
): ParagraphElement {
  const { children, paraProps = {} } = args;

  return {
    alignment: 'left',
    children,
    indentationFirstLine: 0,
    indentationLeft: 0,
    indentationRight: 0,
    lineSpacing: 1.15,
    locationId: generateLocationId(),
    spacingAfter: 0,
    spacingBefore: 0,
    suggestedEdits: [],
    type: paragraphType,
    variant: defaultStyleVariant,
    ...paraProps,
  };
}
